import React from 'react'
import cn from 'classnames'

import { UIComponent } from '../types'
import Typography from '../Typography/Typography'

import styles from './Box.module.css'

interface BoxProps extends UIComponent {
  title?: string
  stack?: boolean
  stackOnMobile?: boolean
  style?: React.CSSProperties
  hideFooter?: boolean
}

const Box: React.FC<BoxProps> = ({
  children,
  title,
  stack,
  stackOnMobile,
  className,
  hideFooter,
  style,
  ...props
}) => {
  return (
    <div
      className={cn(
        styles.box,
        {
          [styles.stack]: stack,
          [styles.stackOnMobile]: !stack && stackOnMobile,
        },
        className,
      )}
      style={style}
      {...props}
    >
      {title && <Typography.H2 className={styles.title}>{title}</Typography.H2>}
      {children}

      {!hideFooter && <div className={styles.footer} />}
    </div>
  )
}

export { Box as default, Box }
